// 嵌套结构 — 与 profile/page.tsx 中的 t('title') / t('tabs.profile') / t('profileTab.contactInfo') / t('editModal.fullName') 等对齐
export const profile = {
  title: "设置",

  // 跨命名空间快捷 — 页面里用 t('common.back')，i18next 把 `.` 当作嵌套分隔符（不是命名空间分隔符），所以放在本命名空间下
  common: {
    back: "返回",
  },

  tabs: {
    profile: "个人资料",
    subscription: "订阅",
  },

  profileTab: {
    friendlyStats: "友谊赛",
    rankedStats: "Acework 排名赛",
    pointsByLevel: "等级积分",
    memberSince: "注册于",
    copied: "已复制",
    contactInfo: "联系信息",
    email: "邮箱",
    phone: "电话",
    location: "所在地",
    preferences: "偏好设置",
    notifications: "通知",
    notificationsDesc: "比赛提醒和更新",
    privacy: "隐私",
    privacyDesc: "个人资料可见性设置",
    security: "安全",
    securityDesc: "密码与身份验证",
    logout: "退出登录",
  },

  subscriptionTab: {
    tiers: {
      free: {
        name: "免费版",
        price: "¥0/月",
        features: [
          "每月最多 5 条友谊赛约局",
          "加入任何约局或赛事",
          "个人比赛历史记录",
          "无 Acework 排名标签",
        ],
      },
      pro: {
        name: "专业版",
        price: "¥35.99/月",
        features: [
          "无限制发布约局",
          "Acework 排名约局（1v1）",
          "Acework 排名赛事（最多 8 人）",
          "城市排行榜排名",
          "Acework 认证徽章",
        ],
        cta: "升级到专业版",
      },
      elite: {
        name: "精英版",
        price: "¥119.99/月",
        features: [
          "专业版的所有功能",
          "Acework 排名赛事（32+ 人）",
          "年终总决赛资格",
          "精英版个人资料徽章",
          "优先客服支持",
        ],
        cta: "升级到精英版",
      },
    },
    currentPlan: "当前方案",
    upgrade: {
      comingSoon: "应用内订阅即将上线，敬请期待。",
    },
  },

  editModal: {
    title: "编辑资料",
    fullName: "姓名",
    namePlaceholder: "输入你的姓名",
    email: "邮箱地址",
    emailPlaceholder: "your@email.com",
    phone: "电话号码",
    phonePlaceholder: "+1 (555) 000-0000",
    country: "国家/地区",
    city: "城市",
    cityCustom: "你的城市",
    location: "所在地",
    locationPlaceholder: "城市，国家/地区",
    ntrpRating: "自评水平（NTRP）",
    cancel: "取消",
    save: "保存更改",
    saving: "保存中...",
  },

  // Legacy flat keys — kept for backwards compatibility with any old code paths.
  ntrp: "NTRP",
};
